type QueryValue = string | number | boolean | null | undefined;

// Laravel's `boolean` rule accepts 1 and 0 but rejects the "true" and "false" a URL carries by default.
const serializeValue = (value: string | number | boolean): string => {
  if (typeof value === "boolean") {
    return value ? "1" : "0";
  }

  return String(value);
};

/** Builds a query string the way Laravel reads it: no empty values, booleans as 1/0, and lists as `key[]`. */
export const serializeLaravelQuery = (params: Record<string, QueryValue | QueryValue[]>): string => {
  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    const isList = Array.isArray(value);

    for (const item of isList ? value : [value]) {
      if (item !== null && item !== undefined) {
        search.append(isList ? `${key}[]` : key, serializeValue(item));
      }
    }
  }

  return search.toString();
};
